module.exports = __webpack_public_path__ + "img/ostruziny-5.46595d89.png";